// extracted by mini-css-extract-plugin
export default {"color":"style_color__GNn5V","font_xm":"style_font_xm__F-nyo"};